import { gql } from '@apollo/client';

export const ALL_ASSOCIATED_ORGANISATION_USERS = gql`
  query AllAssociatedOrganisationUsers($input: OrganisationUserFilterInput!) {
    users: allAssociatedOrganisationUsers(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          email
          firstName
          lastName
          serviceProvider {
            id
            name
          }
          institution {
            id
            name
            cohorts {
              id
              name
            }
          }
          funder {
            id
            name
          }
        }
      }
    }
  }
`;
